if (!customElements.get('best-sellers-tabs')) {
  class BestSellersTabs extends HTMLElement {
    constructor() {
      super();
      this.tabs = this.querySelectorAll('[data-best-sellers-tab]');
      this.panels = this.querySelectorAll('[data-best-sellers-panel]');
      this.bindEvents();
      this.activateInitialTab();
    }

    bindEvents() {
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          this.activateTab(tab.dataset.bestSellersTab);
        });
      });
    }

    activateInitialTab() {
      const initialTab = this.tabs[0];
      if (!initialTab) return;
      this.activateTab(initialTab.dataset.bestSellersTab);
    }

    activateTab(tabId) {
      this.tabs.forEach((tab) => {
        const isActive = tab.dataset.bestSellersTab === tabId;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.panels.forEach((panel) => {
        const isActive = panel.dataset.bestSellersPanel === tabId;
        panel.toggleAttribute('hidden', !isActive);
      });
    }
  }

  customElements.define('best-sellers-tabs', BestSellersTabs);
}
